import axios from 'axios';
import {useState, useEffect} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from "@mui/material/Box";

import Loading from '../../common/Loading';
import Error from '../../common/Error';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function CustomersEditParentCustomer(props) {
    //console.debug("RTS Break CustomerEditParentCustomer");

    const {userAuthToken, apiRoot} = useSessionContext();

    const [customer, setCustomer] = useState(props.parentCustomer);
    const [repoCustomers, setRepoCustomers] = useState([]);

    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);


    function fetchData(){
        let apiURL = apiRoot + "/Customers/GetParentLookup";
        axios
        .get(
            apiURL,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setRepoCustomers(response.data);
            }
            setIsLoading(false);
            if(hasError){
                setHasError(false);
            }
        })
        .catch(error => {
            setIsLoading(false);
            console.log("RTS Data Error", error);
            setHasError(true);
        });
    }


    useEffect(() => {
        fetchData();
    }, []); 

    
    function valChange(e, val){
        props.setParentCustomerFx(val);
        setCustomer(val);
    }


    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }

    return(
        <>
            <Autocomplete
                options={repoCustomers}
                renderInput={(params) => <TextField {...params} label="Parent Customer" autoComplete='new-password' margin="normal" size="small" />}
                value={customer}
                onChange={valChange}
                getOptionLabel={(repoValue) => repoValue.name + ' (' + repoValue.idSap + ')'}
                renderOption={(props, repoCustomers) => (
                    <Box component="li" {...props} key={repoCustomers.idGuid}>
                        {repoCustomers.name + ' (' + repoCustomers.idSap + ')'}
                    </Box>
                )}
                isOptionEqualToValue={(option, value) => option.idGuid === value.idGuid}                
            />
        </>
    );
}

